<div class="proposal-page">
  <div class="proposal-blur proposal-blur-1"></div>
  <div class="proposal-blur proposal-blur-2"></div>
  <div class="proposal-blur proposal-blur-3"></div>

  <div class="proposal-shell">
    <div class="proposal-modal-backdrop" *ngIf="isEditingHeader">
      <div class="proposal-modal">
        <button type="button" class="modal-close" (click)="isEditingHeader = false">
          <i class="mdi mdi-close"></i>
        </button>

        <div class="modal-header">
          <h2>Dados da Proposta</h2>
          <p>Atualize as informações do cliente</p>
        </div>

        <form class="modal-form" (ngSubmit)="saveHeader()">
          <label>
            <span>Nome do Cliente</span>
            <input
              type="text"
              required
              name="clientName"
              [(ngModel)]="clientName"
              placeholder="Ex: Fernando">
          </label>

          <label>
            <span>Nome da Empresa</span>
            <input
              type="text"
              required
              name="companyName"
              [(ngModel)]="companyName"
              placeholder="Ex: Dog Paulista">
          </label>

          <div class="modal-grid">
            <label>
              <span>Localização</span>
              <input
                type="text"
                required
                name="location"
                [(ngModel)]="location"
                placeholder="Ex: São Paulo - SP">
            </label>

            <label>
              <span>Mês da Proposta</span>
              <input
                type="text"
                required
                name="proposalDate"
                [(ngModel)]="proposalDate"
                placeholder="Ex: Março 2026">
            </label>
          </div>

          <label>
            <span>Perfil de Preço (Tabela)</span>
            <select name="pricingTier" [(ngModel)]="pricingTier">
              <option value="iniciante">Iniciante (Lojas Pequenas)</option>
              <option value="padrao">Padrão (Tabela Oficial)</option>
              <option value="avancado">Premium (Grandes Operações)</option>
            </select>
          </label>

          <button
            type="submit"
            class="modal-submit"
            [disabled]="!clientName || !companyName || !location || !proposalDate">
            <span>Salvar e Atualizar</span>
            <i class="mdi mdi-arrow-right"></i>
          </button>
        </form>
      </div>
    </div>

    <header class="hero">
      <div class="brand-mark">
        <img
          src="https://meucardapio.ai/wp-content/uploads/2025/10/Marca-Branca-Transparente-Meu-Cardapio-2048x662.png"
          alt="Logo Meu Cardápio">
      </div>

      <h1>
        <span>Proposta</span>
        <strong>Comercial</strong>
      </h1>

      <div
        class="client-card"
        (click)="isEditingHeader = true"
        title="Clique para editar os dados do cliente">
        <div class="client-card-bar"></div>

        <div class="client-card-edit">
          <i class="mdi mdi-pencil"></i>
        </div>

        <p>Preparada com carinho para</p>
        <h2>{{ clientName }}</h2>

        <div class="client-company">
          <i class="mdi mdi-heart heart-icon"></i>
          <span>{{ companyName }}</span>
        </div>

        <div class="client-meta">
          <span>📍 {{ location }}</span>
          <span>📅 {{ proposalDate }}</span>
        </div>
      </div>
    </header>

    <section class="social-proof">
      <div class="social-proof-card">
        <div class="social-proof-icon">
          <i class="mdi mdi-rocket"></i>
        </div>

        <div>
          <h3>+1.000 restaurantes confiam no MeuCardapio</h3>
          <p>
            Resultados comprovados:
            <strong>+40% vendas diretas</strong>
            <span>•</span>
            <strong>-50% erros de pedido</strong>
            <span>•</span>
            Resposta em menos de 1 min
          </p>
        </div>
      </div>
    </section>

    <section class="plans-section">
      <div class="section-heading">
        <h2>Escolha seu Plano</h2>
        <p>O sistema é sempre completo — você só escolhe o período de compromisso.</p>

        <button
          type="button"
          class="promo-toggle"
          [class.active]="isAnniversaryPromo"
          (click)="toggleAnniversaryPromo()"
          title="Aplicar desconto de 6 anos">
          <span>🎁</span>
          Especial 6 Anos
        </button>
      </div>

      <div class="plans-grid">
        <button
          type="button"
          class="plan-card"
          *ngFor="let plan of activePlans; let i = index"
          [class.selected]="selectedPlan === i"
          [class.highlight]="plan.highlight"
          (click)="selectPlan(i)">

          <div class="plan-badge" *ngIf="plan.highlight">
            <i class="mdi mdi-star"></i>
            MAIS VENDIDO
          </div>

          <div class="plan-top">
            <p>{{ plan.name }}</p>

            <div class="price-row">
              <span class="discount" *ngIf="plan.anchorPrice">
                -{{ discountPercent(plan) }}%
              </span>

              <div class="plan-price">
                <span class="currency">R$</span>
                <span class="int">{{ priceInt(plan.price) }}</span>
                <span class="dec">{{ priceDec(plan.price) }}</span>
              </div>
            </div>

            <div class="plan-meta">
              <span *ngIf="plan.anchorPrice">
                De:
                <strong class="line-through">R$ {{ formatCurrency(plan.anchorPrice) }}</strong>
              </span>
              <span *ngIf="!plan.anchorPrice" class="invisible">Espaçador</span>
              <span>/mês</span>
            </div>
          </div>

          <div class="plan-bottom">
            <div class="plan-line">
              <i class="mdi mdi-check-circle-outline"></i>
              <span><strong>{{ plan.installments }}</strong> no cartão ou PIX</span>
            </div>

            <div class="adhesion-card" [class.free]="plan.adhesion === 0">
              <ng-container *ngIf="plan.adhesion === 0; else adhesionValue">
                <span>🎉 Adesão Grátis</span>
              </ng-container>
              <ng-template #adhesionValue>
                <strong>Adesão: R$ {{ formatCurrency(plan.adhesion) }}</strong>
                <small>ou {{ plan.adhesionInstallments }}</small>
              </ng-template>
            </div>

            <div class="savings-slot">
              <div class="savings-card" *ngIf="plan.savings">
                <span>💰</span>
                Economia de {{ plan.savings }}
              </div>
            </div>
          </div>
        </button>
      </div>
    </section>

    <section class="features-section">
      <div class="surface-card">
        <h3
          class="features-title"
          (click)="isEditingFeatures = !isEditingFeatures"
          title="Clique para selecionar quais itens mostrar">
          <span class="title-icon"><i class="mdi mdi-check-circle-outline"></i></span>
          <span>Tudo que está incluso no seu plano</span>
          <span class="edit-pill" *ngIf="isEditingFeatures">Modo de Edição</span>
        </h3>

        <div class="features-grid">
          <ng-container *ngFor="let group of featureGroups">
            <div
              class="feature-group"
              *ngIf="isEditingFeatures || visibleItems(group).length > 0">
              <div class="feature-group-head">
                <div class="feature-group-icon">
                  <i [class]="group.iconClass"></i>
                </div>
                <h4>{{ group.title }}</h4>
              </div>

              <div class="feature-items">
                <ng-container *ngFor="let item of group.items">
                  <div
                    class="feature-item"
                    *ngIf="isEditingFeatures || isFeatureVisible(item)"
                    [class.editing]="isEditingFeatures"
                    (click)="isEditingFeatures && toggleFeatureVisibility(item)">
                    <div class="feature-checkbox" *ngIf="isEditingFeatures" [class.checked]="isFeatureVisible(item)">
                      <i class="mdi mdi-check" *ngIf="isFeatureVisible(item)"></i>
                    </div>

                    <i class="mdi mdi-check feature-check" *ngIf="!isEditingFeatures"></i>

                    <span [class.hidden-item]="!isFeatureVisible(item)">{{ item }}</span>
                  </div>
                </ng-container>
              </div>
            </div>
          </ng-container>
        </div>

        <div class="feature-actions" *ngIf="isEditingFeatures">
          <button type="button" class="ghost-btn" (click)="hiddenFeatures = {}">👁️ Mostrar Todos</button>
          <button type="button" class="dark-btn" (click)="isEditingFeatures = false">Concluir Edição</button>
        </div>
      </div>
    </section>

    <section class="addons-section">
      <div class="section-heading">
        <h2>Monte sua Operação</h2>
        <p>Adicione os módulos que fazem sentido pra {{ companyName }} hoje.</p>
      </div>

      <div class="addons-grid">
        <button
          type="button"
          class="addon-card"
          *ngFor="let addon of addons; let i = index"
          [class.selected]="selectedAddons[i]"
          (click)="toggleAddon(i)">
          <div class="addon-head">
            <span>{{ addon.name }}</span>
            <div class="addon-check" [class.checked]="selectedAddons[i]">
              <i class="mdi mdi-check"></i>
            </div>
          </div>

          <div class="addon-body" *ngIf="addon.features; else simpleAddon">
            <div class="addon-feature" *ngFor="let feature of addon.features">
              <i class="mdi mdi-check"></i>
              <span>{{ feature }}</span>
            </div>
          </div>

          <ng-template #simpleAddon>
            <p class="addon-desc">{{ addonDescription(addon) || addon.desc }}</p>
          </ng-template>

          <div class="addon-footer">
            <div class="addon-price" *ngIf="!exemptAddons[i]; else freeAddon">
              <strong>+ R$ {{ formatCurrency(addon.price) }}</strong>
              <span>/mês</span>
            </div>

            <ng-template #freeAddon>
              <div class="addon-price free">
                <small>De R$ {{ formatCurrency(addon.price) }}</small>
                <strong>Grátis</strong>
              </div>
            </ng-template>

            <button
              type="button"
              class="gift-btn"
              [class.active]="exemptAddons[i]"
              [title]="exemptAddons[i] ? 'Remover isenção' : 'Isentar este módulo'"
              (click)="toggleExempt($event, i)">
              <i class="mdi mdi-gift"></i>
            </button>
          </div>
        </button>
      </div>

      <div class="summary-shell">
        <div class="summary-panel">
          <div class="summary-card">
            <div class="summary-header">
              <h4><span>🛒</span> Resumo da Negociação</h4>

              <div class="summary-tools">
                <button type="button" class="round-btn" [class.active]="showPix" (click)="showPix = !showPix" title="Adicionar Desconto PIX à vista">
                  <i class="mdi mdi-flash"></i>
                </button>

                <button type="button" class="round-btn" (click)="showAdjustmentInput = !showAdjustmentInput" title="Adicionar Ajuste Comercial Extra">
                  <i class="mdi mdi-account-group"></i>
                </button>
              </div>
            </div>

            <div class="summary-lines">
              <div class="summary-line summary-plan">
                <span>Plano {{ currentPlan.name }}</span>

                <div class="summary-editors">
                  <input
                    type="text"
                    [ngModel]="activeInstallments"
                    (ngModelChange)="setActiveInstallments($event)"
                    name="activeInstallments">
                  <span>x R$</span>
                  <input
                    type="number"
                    step="0.01"
                    [ngModel]="activePrice === 0 ? null : activePrice"
                    (ngModelChange)="setActivePrice($event)"
                    name="activePrice">
                </div>
              </div>

              <div class="summary-addon" *ngFor="let addon of addons; let i = index">
                <ng-container *ngIf="selectedAddons[i]">
                  <span>
                    <i class="mdi mdi-plus"></i>
                    {{ addon.name }}
                  </span>
                  <strong *ngIf="!exemptAddons[i]">R$ {{ formatCurrency(addon.price) }}</strong>
                  <strong *ngIf="exemptAddons[i]" class="free-pill">Grátis</strong>
                </ng-container>
              </div>

              <div class="summary-line accent green" *ngIf="showPix">
                <span><i class="mdi mdi-flash"></i> PIX à vista</span>
                <div class="percent-editor">
                  <span>-</span>
                  <input
                    type="number"
                    step="0.1"
                    [ngModel]="pixPercent === 0 ? null : pixPercent"
                    (ngModelChange)="setPixPercent($event)"
                    name="pixPercent">
                  <span>%</span>
                  <small *ngIf="pixDiscountValue > 0">(R$ {{ pixDiscountValue }})</small>
                </div>
              </div>

              <div class="summary-line accent yellow" *ngIf="totalNegotiatedDiscount > 0">
                <span><i class="mdi mdi-tag"></i> Desconto Negociado</span>
                <strong>- R$ {{ formatCurrency(totalNegotiatedDiscount) }}</strong>
              </div>

              <div class="summary-line accent yellow muted" *ngIf="showAdjustmentInput">
                <div class="label-editor">
                  <i class="mdi mdi-tag"></i>
                  <input type="text" [(ngModel)]="adjustmentLabel" name="adjustmentLabel">
                </div>

                <div class="value-editor">
                  <span>- R$</span>
                  <input
                    type="number"
                    step="0.01"
                    [ngModel]="extraAdjustment === 0 ? null : extraAdjustment"
                    (ngModelChange)="setExtraAdjustment($event)"
                    name="extraAdjustment">
                </div>
              </div>

              <div class="summary-line summary-adhesion">
                <span>Adesão do Sistema</span>
                <div class="summary-editors">
                  <strong *ngIf="activeAdhesion === 0" class="free-badge">Grátis</strong>
                  <span>R$</span>
                  <input
                    type="number"
                    step="0.01"
                    [ngModel]="activeAdhesion === 0 ? null : activeAdhesion"
                    (ngModelChange)="setActiveAdhesion($event)"
                    name="activeAdhesion">
                </div>
              </div>
            </div>
          </div>

          <div class="summary-total">
            <p>Investimento Mensal</p>

            <div class="original-price" *ngIf="totalNegotiatedDiscount > 0">
              <span class="opportunity-pill">Oportunidade</span>
              <span>De: <strong>R$ {{ formatCurrency(originalSubtotal) }}</strong></span>
            </div>

            <div class="total-price">
              <span class="rs">R$</span>
              <span class="int">{{ totalInt }}</span>
              <span class="dec">,{{ totalDec }}</span>
              <span class="period">/mês</span>
            </div>

            <div class="upfront-pill" *ngIf="showPix">
              <span>⚡</span>
              Total à vista: R$ {{ formatCurrency(totalUpfront) }}
            </div>

            <div class="economy-pill" *ngIf="premiumYearlySavings > 0">
              <div>💎 Você economiza R$ {{ formatCurrency(premiumYearlySavings) }}/ano!</div>
              <small>*Em relação à Tabela Premium</small>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="guarantees-section">
      <div class="surface-card">
        <h3 class="section-card-title">
          <span class="title-icon shield"><i class="mdi mdi-shield-check-outline"></i></span>
          Nosso Compromisso com a {{ companyName }}
        </h3>

        <div class="guarantees-grid">
          <div class="guarantee-item" *ngFor="let guarantee of guarantees">
            <i class="mdi mdi-shield-check-outline"></i>
            <span>{{ guarantee }}</span>
          </div>
        </div>
      </div>
    </section>

    <section class="comparison-section">
      <button type="button" class="comparison-toggle" (click)="showComparison = !showComparison">
        <div>
          <h3><span>🧐</span> Por que o MeuCardapio e não os outros?</h3>
          <p>Veja o comparativo real com o Anota.ai</p>
        </div>
        <div class="comparison-chevron" [class.open]="showComparison">
          <i class="mdi mdi-chevron-down"></i>
        </div>
      </button>

      <div class="comparison-body" [class.open]="showComparison">
        <div class="comparison-table-wrap">
          <table>
            <thead>
              <tr>
                <th>Funcionalidade / Regra</th>
                <th class="us">MeuCardapio</th>
                <th>Anota.ai</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of comparisonData; let i = index" [class.alt]="i % 2 === 1">
                <td>{{ item[0] }}</td>
                <td class="us">
                  <i [class]="item[1] ? 'mdi mdi-check success' : 'mdi mdi-close danger'"></i>
                </td>
                <td>
                  <i [class]="item[2] ? 'mdi mdi-check neutral' : 'mdi mdi-close muted'"></i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>

    <section class="cta-section">
      <div class="cta-card">
        <div class="cta-icon">
          <i class="mdi mdi-rocket"></i>
        </div>

        <h3>Sua loja abre dia 10 de março!</h3>
        <p>
          Damos conta do recado. Implantamos tudo
          <strong>em apenas 48h úteis após o envio dos dados</strong>
          para garantir que você tenha tempo de testar tudo com calma antes da grande inauguração.
        </p>

        <button type="button" class="cta-button">
          <i class="mdi mdi-whatsapp"></i>
          <span>Bora fechar no WhatsApp!</span>
          <i class="mdi mdi-arrow-right"></i>
        </button>

        <small>Sem compromisso • Fale com o Márcio e tire todas as dúvidas</small>
      </div>
    </section>

    <footer class="proposal-footer">
      <div>
        MeuCardapio &copy; {{ currentYear }} • Proposta válida por 7 dias
      </div>
    </footer>
  </div>
</div>
